<template lang='pug' src='./comfort-care.pug'></template>

<script>
import Loader from 'components/loader/loader'
import BlockTitle from 'components/block/block-title/block-title'
import BlockSvgTitle from 'components/block/block-svg-title/block-svg-title'
import CustomComfortCareSections from 'components/custom/custom-comfort-care-sections/custom-comfort-care-sections'
import SliderAboutOffice from 'components/slider/slider-about-office/slider-about-office'
import SliderAboutUsTeam from 'components/slider/slider-about-us-team/slider-about-us-team'

export default {
  name: 'comfort-care',
  computed: {
    props () {
      return this.$store.state.pages['comfort-care']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    BlockTitle,
    BlockSvgTitle,
    CustomComfortCareSections,
    SliderAboutOffice,
    SliderAboutUsTeam
  }
}
</script>



// WEBPACK FOOTER //
// comfort-care.vue?305a4ce2